import { useSelector } from "react-redux";
import { TableRiskStrat } from "../../../../../../../../ui";
import { getAcronym } from "../../../../../../../../utils/getFunctions/getFormattedLabels";

export const RiskStratificationTable = () => {
  const { result } = useSelector((state) => state.ipssm);
  return <TableRiskStrat activeCategory={getAcronym(result?.means?.riskCat)} />;
};
